import { LocationVarKey } from "@swivl-mono/types";

import { IS_NOT_EQUAL, IS_EQUAL, IF_ANY } from "../../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../../Hooks/usePropertiesGetLocationIds";

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} 
        subheading="This worksheet controls your spot Referral pages and profile collections.">
        {" "}
        spot Referrals{" "}
      </PageHeader>
      
      <SectionHeader {...page} subheading="The content that is displayed on your public facing spot.is URL">
        {" "}
        spot Page Settings{" "}
      </SectionHeader>

      <InputRow {...page} keyName={LocationVarKey.ReferralIncentive} label="Referral Incentive"/>


      <InputRow {...page} keyName={LocationVarKey.SpotReferralPageTitle} label="Page Title / Email Subject" />

      <TextAreaRow {...page} marginTop label=" Body" keyName={LocationVarKey.SpotReferralPageBody} />

      <TextAreaRow {...page} marginTop label=" Link" keyName={LocationVarKey.SpotReferralURL} />

      <SectionHeader {...page} subheading='Message shown in chat to the referrer after they click "Refer a Friend" on the spot page'>
        {" "}
        Chat Message{" "}
      </SectionHeader>

      <TextAreaRow {...page} marginTop label=" Body" keyName={LocationVarKey.SpotReferralInChatMessage} />


      <SectionHeader {...page} subheading="This content is included in the message we send to the recipient of the referral">
        {" "}
        Share Options{" "}
      </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Email Subject" keyName={LocationVarKey.SpotReferralShareEmailSubject} />

      <TextAreaRow {...page} marginTop label=" Email Body" keyName={LocationVarKey.SpotReferralShareEmailBody} />

      <TextAreaRow {...page} marginTop label=" SMS Body" keyName={LocationVarKey.SpotReferralShareSMSBody} />

      <SectionHeader
        {...page}
        subheading="The person being referred will be sent to a webpage where the chat will open and collect their information"
      >
        {" "}
        In-Chat Referral Collection{" "}
      </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SpotReferralMessage1} />

      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2"
        keyName={LocationVarKey.SpotReferralMessage2}
        enableSwitchVar={LocationVarKey.SpotReferralMessage2Enabled}
      />

      <DropdownRow
        {...page}
        marginTop
        label=" Collection Method"
        keyName={LocationVarKey.SpotReferralReferralCollectionMethod}
        options={[
          {
            label: "Conversational",
            value: "Conversational",
          },
          {
            label: "Info Collect Card",
            value: "Card",
          },
        ]}
      />
      <DropdownRow
        {...page}
        marginTop
        label=" Preferred Contact Method"
        keyName={LocationVarKey.SpotReferralReferralContactMethod}
        options={[
          {
            label: "Phone Number",
            value: "Phone",
          },
          {
            label: "Email",
            value: "Email",
          },
        ]}
      />
      <SwitchRow {...page} keyName={LocationVarKey.SpotReferralReferralWantShortProfile} label="Short Profile" />
      <Indent {...page}>
        <SwitchRow
          {...page}
          keyName={LocationVarKey.SpotReferralReferralWantSecondaryOptional}
          hideIf={IS_NOT_EQUAL(LocationVarKey.SpotReferralReferralWantShortProfile, "1")}
          label="Make Secondary Contact Method Optional"
        />
      </Indent>

      <TextAreaRow {...page} marginTop label=" Message after profile is collected" keyName={LocationVarKey.SpotReferralReferralConfirm1} />
    </>
  );
}
